export const getNavBarWithEventHeaderHeight = () => {
  const navBarHeight = Number.parseInt(
    document.documentElement.style.getPropertyValue('--navbar-height'),
  )
  const eventHeaderWithPaddingHeight = 60
  return navBarHeight + eventHeaderWithPaddingHeight
}
